import router from '../router';
import store from '../store';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({ showSpinner: false });

const whiteList = ['/login'];

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (whiteList.includes(to.path)) {
    next();
  } else if (localStorage.getItem('ipp_token')) {
    const role = localStorage.getItem('ipp_role');
    if (role) {
      if (['superadmin', 'administrator'].includes(role)) next();
      else if (!(to.meta && to.meta.roles && to.meta.roles.length)) next();
      else if ((to.meta.roles || []).includes(role)) next();
      else next('/403');
    } else next(`/login`);
  } else {
    console.log('no token', to, from);
    const { id, token } = to.query;
    if (id && token) {
      next();
    } else {
      next(`/login`);
    }
  }
  NProgress.done();
});

router.afterEach(() => {
  NProgress.done();
});
